import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import navigationReducer from "./navigationReducer";


export default combineReducers({
  loginReducer,
    navigationReducer: navigationReducer,
});
